import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * Poseidon Agent CPUのフォームのベースです。
 * NOTE: Chakra の Input は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const PoseidonAgentCpuFormBase: FC<Props> = ({ register }) => (
  <Input
    id="poseidonAgentCpu"
    type="text"
    placeholder="例: 100m"
    {...register('poseidonAgentCpu', {
      required: {
        value: true,
        message: 'Poseidon Agent CPUは必須です。',
      },
      maxLength: {
        value: 50,
        message: 'Poseidon Agent CPUは 50 文字以内にする必要があります。',
      },
    })}
  />
);
